module.exports = __webpack_public_path__ + "static/media/filip-mroz-sgtxFOiBZmQ-unsplash.a1d39d1d.png";